import { FC, ReactNode } from "react";
import { useIsCollapsed } from "~/hooks/useIsCollapsed";
import { CommentCollapsible } from "./CommentCollapsible";

interface Props {
  children: ReactNode;
  initialShow?: boolean;
}

export const LaurenQuoteMobile: FC<Props> = ({ children, initialShow }) => {
  const isCollapsed = useIsCollapsed();
  const component = isCollapsed && (
    <CommentCollapsible initialShow={initialShow}>
      {children}
    </CommentCollapsible>
  );

  return component;
};
